import React from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const AssetTableHeader = ({
  items = [],
  totalRecords = 0,
  currentPage = 1,
  totalPages = 1,
  assetCount = 0,
  gotoPage = () => {},
  handleResetInputs = () => {},
  tableContainerRef,
}) => {
  return (
    <>
      <div className="flex items-center justify-between w-full mb-4">
        <div className="flex items-center space-x-8">
          <div className="flex space-x-6">
            {items.map((item, idx) => (
              <div key={idx} className="flex items-center space-x-2">
                <div
                  className="w-[14px] h-[50px] rounded-full"
                  style={{ backgroundColor: item.color.trim() }}
                />
                <div className="flex flex-col text-sm text-gray-500">
                  <span style={{ fontSize: "12px" }}>DQ Score</span>
                  <span style={{ fontSize: "12px" }}>{item.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          {totalRecords > 0 && (
            <div className="pagination-controls flex items-center gap-2">
              <button
                disabled={currentPage === 1}
                onClick={() => gotoPage(currentPage - 1)}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Previous
              </button>

              {(() => {
                const pageButtons = [];
                const totalToShow = 5;

                let start = Math.max(1, currentPage - Math.floor(totalToShow / 2));
                let end = start + totalToShow - 1;

                if (end > totalPages) {
                  end = totalPages;
                  start = Math.max(1, end - totalToShow + 1);
                }

                if (start > 1) pageButtons.push(1);
                if (start > 2) pageButtons.push("...");

                for (let i = start; i <= end; i++) pageButtons.push(i);

                if (end < totalPages - 1) pageButtons.push("...");
                if (end < totalPages) pageButtons.push(totalPages);

                return pageButtons.map((p, idx) =>
                  p === "..." ? (
                    <span key={idx} className="px-2">
                      ...
                    </span>
                  ) : (
                    <button
                      key={idx}
                      onClick={() => gotoPage(p)}
                      className={`px-3 py-1 border rounded ${
                        currentPage === p ? "bg-[#bb1ccc] text-white" : ""
                      }`}
                    >
                      {p}
                    </button>
                  )
                );
              })()}

              <button
                disabled={currentPage === totalPages}
                onClick={() => gotoPage(currentPage + 1)}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3 mb-[10px]">
          <button
            className="px-3 mt-[4px] w-[100px] py-1 text-gray-700 bg-white border border-gray-300 rounded"
            onClick={handleResetInputs}
          >
            Reset
          </button>

          <div className="flex items-center gap-1 mt-[3px]">
            <ChevronLeft
              title="Scroll Left"
              className="cursor-pointer"
              onClick={() => {
                if (tableContainerRef?.current) {
                  tableContainerRef.current.scrollBy({
                    left: -200,
                    behavior: "smooth",
                  });
                }
              }}
            />
            <p className="text-[12px]">Scroll</p>
            <ChevronRight
              title="Scroll Right"
              className="cursor-pointer"
              onClick={() => {
                if (tableContainerRef?.current) {
                  tableContainerRef.current.scrollBy({
                    left: 200,
                    behavior: "smooth",
                  });
                }
              }}
            />
          </div>
        </div>

        <div className="mb-[10px]">
          <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-md shadow-sm">
            THERE ARE {assetCount} UNIQUE ASSETS FOUND
          </span>
        </div>
      </div>
    </>
  );
};

export default AssetTableHeader;
